/* src/components/Fastboard/ReplayFastboard.svelte generated by Svelte v3.54.0 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	not_equal,
	space,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

import { onMount } from "svelte";
import { tippy_hide_all } from "../../actions/tippy";
import PlayerControl from "../PlayerControl";

function create_fragment(ctx) {
	let div2;
	let div0;
	let div0_class_value;
	let t;
	let div1;
	let playercontrol;
	let div1_class_value;
	let div2_class_value;
	let current;
	let mounted;
	let dispose;

	playercontrol = new PlayerControl({
			props: {
				player: /*player*/ ctx[0],
				theme: /*theme*/ ctx[1],
				language: /*language*/ ctx[2]
			}
		});

	return {
		c() {
			div2 = element("div");
			div0 = element("div");
			t = space();
			div1 = element("div");
			create_component(playercontrol.$$.fragment);
			attr(div0, "class", div0_class_value = "" + (name + "-view"));
			attr(div1, "class", div1_class_value = "" + (name + "-bottom"));
			attr(div2, "class", div2_class_value = "" + (name + "-root"));
			toggle_class(div2, "loading", !/*player*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, div2, anchor);
			append(div2, div0);
			/*div0_binding*/ ctx[7](div0);
			append(div2, t);
			append(div2, div1);
			mount_component(playercontrol, div1, null);
			current = true;

			if (!mounted) {
				dispose = listen(div0, "touchstart", /*focus_me*/ ctx[4], { passive: true, capture: true });
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			const playercontrol_changes = {};
			if (dirty & /*player*/ 1) playercontrol_changes.player = /*player*/ ctx[0];
			if (dirty & /*theme*/ 2) playercontrol_changes.theme = /*theme*/ ctx[1];
			if (dirty & /*language*/ 4) playercontrol_changes.language = /*language*/ ctx[2];
			playercontrol.$set(playercontrol_changes);

			if (!current || dirty & /*player*/ 1) {
				toggle_class(div2, "loading", !/*player*/ ctx[0]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(playercontrol.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(playercontrol.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div2);
			/*div0_binding*/ ctx[7](null);
			destroy_component(playercontrol);
			mounted = false;
			dispose();
		}
	};
}

const name = "fastboard";

function instance($$self, $$props, $$invalidate) {
	let { player = null } = $$props;
	let { theme = "light" } = $$props;
	let { language = "en" } = $$props;
	let { containerRef = void 0 } = $$props;
	let container;
	let mounted = false;

	onMount(() => {
		if (containerRef) {
			containerRef(container);

			return () => {
				if (containerRef) containerRef(null);
			};
		}
	});

	function focus_me() {
		tippy_hide_all();
		let a = document.activeElement;
		a && a.blur && a.blur();
	}

	function div0_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			container = $$value;
			$$invalidate(3, container);
		});
	}

	$$self.$$set = $$props => {
		if ('player' in $$props) $$invalidate(0, player = $$props.player);
		if ('theme' in $$props) $$invalidate(1, theme = $$props.theme);
		if ('language' in $$props) $$invalidate(2, language = $$props.language);
		if ('containerRef' in $$props) $$invalidate(5, containerRef = $$props.containerRef);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*player, container*/ 9) {
			$: try {
				if (player && container) {
					player.bindContainer(container);
					$$invalidate(6, mounted = true);
				}
			} catch(err) {
				console.error("[fastboard] An error occurred while binding container");
				console.error(err);
			}
		}

		if ($$self.$$.dirty & /*player, theme, mounted*/ 67) {
			$: if (player && theme && mounted) {
				player.manager.setPrefersColorScheme(theme);
			}
		}
	};

	return [
		player,
		theme,
		language,
		container,
		focus_me,
		containerRef,
		mounted,
		div0_binding
	];
}

class ReplayFastboard extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, not_equal, {
			player: 0,
			theme: 1,
			language: 2,
			containerRef: 5
		});
	}
}

export default ReplayFastboard;